export const Width = {
  none: "0",
  xs: "0.125rem", // "1px"
  sm: "0.25rem", // "2px"
  md: "0.375rem", // "3px"
  lg: "0.5rem", // "4px"
  xl: "0.75rem", // "6px"
};

export const Style = {
  none: "none",
  solid: "solid",
  dotted: "dotted",
  dashed: "dashed",
  double: "double",
  groove: "groove",
  ridge: "ridge",
  inset: "inset",
  outset: "outset",
};

export const Radius = {
  none: "0",
  sm: "0.125rem",
  md: "0.375rem",
  lg: "0.5rem",
  xl: "0.75rem",
  "2xl": "1rem",
  "3xl": "1.5rem",
  full: "9999px",
};

export const Borders = {
  Width,
  Style,
  Radius,
};
